export default function hasPermission(
  usersPermissions: string[], necessaryPermissions: string[]
): boolean {
  if (!necessaryPermissions || !necessaryPermissions.length) {
    return true;
  }
  const permissionFound = necessaryPermissions.some((e) => usersPermissions.includes(e));
  return permissionFound;
}
